<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-filter-item-multi-select" v-if="filter">
    <el-dropdown-item v-if="filter.type=='select'">
      <span class="filter-title">{{filter.label}}</span>
      <el-select
        v-model="filter.value"
        filterable
        :popper-append-to-body="true"
        clearable>
        <el-option
          v-for="item in localDataSource"
          :key="item.key"
          :label="item.label ? item.label : item.key"
          :value="item.key"> 
        </el-option>
      </el-select>
    </el-dropdown-item>
    <el-dropdown-item v-if="filter.type=='multiSelectCheckbox'">
      <span class="filter-title">{{filter.label}}:</span>
      <el-select
        v-model="filter.value"
        multiple
        ref="MoreFilterDropDowns"
        collapse-tags
        :disabled="filter.isEmpty || filter.isDisabled || dropdownDisabled"
        :placeholder="(filter.isEmpty ? `No ${filter.label}` : this.placeholder)"
        @focus="handleFocus(filter.placeholder, $event)"
        filterable
        @visible-change = "isChanged"
        :filter-method="filterMethod"
        @change="filterChanged($event)"
        @remove-tag="removeTag"
        :popper-class="largeRecord?'large-record '+ className + ` with-checkbox ` : className + ` with-checkbox `"
        :popper-append-to-body="true">
        <el-option
          v-for="(item) in localDataSource"
          :title="item.label"
          :key="item.key"
          :label="item.label"
          :value="item.key">
          <!-- <label @click="labelClick" class="label-click"><input class="check-box-click" :checked="filter.value.includes(item.key)" @click="checkboxClick" type="checkbox" :name="item.key" :value="item.key">{{item.label}}</label> -->
          <input class="check-box-click" :checked="filter.value.includes(item.key)" @click="checkboxClick" type="checkbox" :name="item.key" :value="item.key"><label @click="labelClick" class="label-click" :value="item.label" v-html="item.label"></label>
          <!-- <input class="check-box-click" :checked="filter.value.includes(item.key)" @click="checkboxClick" type="checkbox" :name="item.key" :value="item.key"><div @click="labelClick" class="label-click" v-html="item.label"></div> -->
        </el-option>
        
      </el-select>
    </el-dropdown-item>
    <el-dropdown-item v-if="filter.type=='multiSelect'">
      <span class="filter-title">{{filter.label}}:</span>
      <el-select
        v-model="filter.value"
        multiple
        ref="MoreFilterDropDowns"
        collapse-tags
        :disabled="filter.isEmpty  || filter.isDisabled"
        :placeholder="(filter.isEmpty ? `No ${filter.label}` : this.placeholder)"
        @focus="handleFocus(filter.placeholder, $event)"
        filterable
        @visible-change = "isChanged"
        @change="filterChanged($event)"
        @remove-tag="removeTag"
        :popper-class="className"
        :popper-append-to-body="true">
        <el-option
          v-for="(item) in localDataSource"
          :title="item.label"
          :key="item.key"
          :label="item.label"
          :value="item.key">
        </el-option>
      </el-select>
    </el-dropdown-item>
  </div>
</template>

<script>
export default {
  name: 'wy-filter-item-multi-select',
  props: {
    filter: Object,
    dataSource: Array,
    filterChangedCallback: Function,
    className: {
      type: String,
      default: 'global-filter-picker-multiple-popper'
    },
    dropdownDisabled: Boolean
  },
  
  data() {
    return {
      preSelectedFilters: [],
      placeholder: "All",
      localDataSource: null,
      dropdownVisible: false,
      cloneLocalDataSource: null,
    }
  },

  computed: {    
    largeRecord() {
      return (this.localDataSource && this.localDataSource.length) > 1000;
    }
  },

  methods: {
    
    isChanged(isOpen){
      if(isOpen){
        this.dropdownVisible = true;
        const dataList = this.dataSource ? this.dataSource : this.filter.dataSource;
        let allItem = null;
        if(dataList && dataList.length > 0 && dataList[0].key == 'all') {
          allItem = dataList.shift();
        }

        let blankItem = null;
        if(dataList && dataList.length > 0 && dataList[0].key == '--') {
          blankItem = dataList.shift();
        }
        dataList.map(item => {
          item.order = this.filter.value.includes(item.key) ? 1 : 0;
        });
        if(this.filter.type == 'multiSelectCheckbox') {
          dataList.sort((a, b) => a.label.localeCompare(b.label))
        }
        else {
          dataList.sort((a, b) => (a.key > b.key) ? 1 : -1)
        }
        dataList.sort((a, b) => (a.order > b.order) ? -1 : 1)
        if(blankItem) dataList.unshift(blankItem);
        if(allItem) dataList.unshift(allItem);
        this.localDataSource = dataList;
        // let scrollDiv = document.querySelector('.global-filter-picker-multiple-popper.with-checkbox.large-record .el-select-dropdown__wrap.el-scrollbar__wrap')
        // scrollDiv.addEventListener("scroll", (event) => {
        //   console.log(event)
        // })
      }
      else {
        this.placeholder = "All";
        this.dropdownVisible = false;
        this.localDataSource = this.cloneLocalDataSource;
        this.filterMethod('')
        // if(this.filterChangedCallback) this.filterChangedCallback();
      }
    },
    handleFocus(filterPlaceholder, e){
      if (this.dropdownVisible) {
        return this.closeDropdown();
      }
      if(this.preSelectedFilters.length == 0 || this.filter.value.length == 0){
        this.placeholder = filterPlaceholder;
      }
      else if (this.preSelectedFilters.length > 0){
        this.placeholder = "";
      }
      if (e.type == 'focus') {
        this.dropdownVisible = true;
      }
    },
    labelClick(e) {
      e.preventDefault()
    },
    checkboxClick(e) {
      e.preventDefault()
    },
    hightLightContent(filter) {
      document.querySelectorAll(".el-select-dropdown.el-popper.is-multiple.with-checkbox .label-click").forEach(el => {
        el.innerHTML = el.innerText;
        if(filter == '') {
          el.innerHTML = el.innerHTML.replace(/<span class='highlight-keywords'>|<\/span>/g, "")
        }
        else {
          el.innerHTML = el.innerHTML.replace(new RegExp(filter, 'gi'), '<span class="highlight-keywords">$&</span>')
        }
      })
    },
    filterMethod(filter) {
      this.localDataSource = this.cloneLocalDataSource;
      this.localDataSource = this.cloneLocalDataSource.filter((item) => item.label.toLowerCase().includes(filter.toLowerCase()))
      if(this.cloneLocalDataSource.length < 2000) {
        setTimeout(()=>{
          this.hightLightContent(filter)
        }, 20)
      }
    },
    filterChanged(item) {
      this.dropdownVisible = false;
      let dataList = [];
      dataList = this.dataSource ? this.dataSource : this.filter.dataSource;
      if(item.includes('all') && !this.preSelectedFilters.includes('all')) {
        this.$el.className = 'wy-filter-item-multi-select selection_all_yes_preselected_no';
        let tempItem = [];
        dataList.forEach(element => { 
          tempItem.push(element.key) 
        });

        this.filter.value = tempItem;
      }
      else if(!item.includes('all') && this.preSelectedFilters.includes('all')){
        this.$el.className = 'wy-filter-item-multi-select selection_all_no_preselected_yes';
        this.filter.value = []
      }
      else if(item.includes('all')) {
        this.$el.className = 'wy-filter-item-multi-select selection_all_yes';
        this.filter.value.splice(this.filter.value.indexOf('all'), 1);
      }
      else if(!item.includes('all') && item.length == dataList.length - 1) {
        // this.$el.className = 'wy-filter-item-multi-select selection_all_no';  // select all need to show the number of items
        // remove the line below becase we don't want to select all when the full list is selected
        //this.filter.value.unshift('all');
      }
      else {
        this.$el.className = 'wy-filter-item-multi-select selection_all_none';
      }
      this.preSelectedFilters = JSON.parse(JSON.stringify(item));
      if(this.filterChangedCallback) this.filterChangedCallback();
    },

    removeTag(tag) {
      if(tag == 'all') {
        this.filter.value = []
      }
    },

    closeDropdown() {
      this.$refs.MoreFilterDropDowns.blur();
      this.dropdownVisible = false;
    }
  },

  created() {
    this.preSelectedFilters = this.filter.value;
  },

  mounted() {
    if(!this.localDataSource) {
      this.localDataSource = this.filter.dataSource;
      this.cloneLocalDataSource = this.filter.dataSource;
    }
  }
}
</script>

<style lang="scss">
.wy-filter-item-multi-select.selection_all_yes_preselected_no {
  span.el-tag.el-tag--info.el-tag--small.el-tag--light:nth-child(2) {
    display: none;
  }
}

.wy-filter-item-multi-select.selection_all_no_preselected_yes {

  span.el-tag.el-tag--info.el-tag--small.el-tag--light:nth-child(2) {
    display: inline;
    position: relative;
    left: -8px;
    width: 47px;
    margin-left: -2px !important;
  }
}

.wy-filter-item-multi-select.selection_all_yes {

  span.el-tag.el-tag--info.el-tag--small.el-tag--light:nth-child(2) {
    display: inline;
    position: relative;
    left: -8px;
    width: 47px;
  }
}

.wy-filter-item-multi-select.selection_all_no {

  span.el-tag.el-tag--info.el-tag--small.el-tag--light:nth-child(2) {
    display: none;
  }
}

.wy-filter-item-multi-select.selection_all_none {

  span.el-tag.el-tag--info.el-tag--small.el-tag--light:nth-child(2) {
    display: inline;
    position: relative;
    left: -8px;
    width: 47px;
  }
}


.global-filter-picker-multiple-popper {
  .popper__arrow{
      border-bottom-color: #0F1A20 !important;
  }
  .popper__arrow::after {
      border-bottom-color: #0F1A20 !important;
  }
}

.el-select-dropdown.el-popper.is-multiple.with-checkbox {
  .el-select-dropdown__item {
    display: flex;
    color: var(--site-interaction-primary-font-color);
  }
  .el-select-dropdown__item.selected {
    background-color: unset !important;
  }
  .el-select-dropdown__item:hover {
    color: var(--site-interaction-primary-hover-font-color) !important;
    background-color: #F6F7F8 !important;
    // background: unset !important;
  }
  .el-select-dropdown__item.selected::after {
    display: none !important;
  }
  .label-click {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    // color: var(--site-interaction-primary-font-color);

    .highlight-keywords {
      // background-color: yellow;
      font-weight: 600;
    }
  }
  .check-box-click {
    pointer-events: none;
    cursor: pointer;
    top: 0px;
    margin: 11px 0px;
    margin-right: 8px;
    position: relative;
  }
  input[type=checkbox]:checked {
    accent-color: #2C86E8;
  }
}

</style> 